import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const malwarebytes = defineConnector({
  identifier: "malwarebytes",
  name: "Malwarebytes",
  tagLine: "Endpoint protection platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.malwarebytes\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your [Malwarebytes Nebula console](https://cloud.malwarebytes.com/) and navigate to **Settings > API Credentials** to generate credentials.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.malwarebytes.com/oauth2/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.malwarebytes.com/nebula/v1/accounts",
  },
});
